import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { LeagueNews } from '@mtgame/core';
import { LoaderService, ToastService } from '@mtgame/ui';
import { LeagueVideoListService } from './league-video-list.service';

@Injectable({providedIn: 'root'})
export class LeagueVideoListResolver implements Resolve<LeagueNews[]> {
  constructor(
    private loaderService: LoaderService,
    private toastService: ToastService,
    private leagueNewsService: LeagueVideoListService,
  ) {
  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<LeagueNews[]> {
    this.loaderService.show();
    try {
      return await this.leagueNewsService.initialize()
    } catch (e) {
      this.toastService.danger('Произошла ошибка');
      throw e;
    } finally {
      this.loaderService.hide();
    }
  }
}
